const createLogger = (config = {})=>{
    const logLevel = config.logLevel ?? 'info';
    const debug = (message, ...args)=>{
        const levelsToLog = [
            'debug',
            'info',
            'warn',
            'error'
        ];
        if (levelsToLog.includes(logLevel)) console.debug(message, ...args);
    };
    const info = (message, ...args)=>{
        const levelsToLog = [
            'info',
            'warn',
            'error'
        ];
        if (levelsToLog.includes(logLevel)) console.info(message, ...args);
    };
    const warn = (message, ...args)=>{
        const levelsToLog = [
            'warn',
            'error'
        ];
        if (levelsToLog.includes(logLevel)) console.warn(message, ...args);
    };
    const error = (message, ...args)=>{
        const levelsToLog = [
            'error'
        ];
        if (levelsToLog.includes(logLevel)) console.error(message, ...args);
    };
    return {
        debug,
        info,
        warn,
        error
    };
};
export { createLogger };
